module.exports = __webpack_public_path__ + "img/comment.fa6559d4.png";